import styled from 'styled-components';
import Theme from '../../../Theme';
import { Text } from '../../../components/core';

type Props = {
  selected?: boolean
  name?: string
  number?: string
  onClick?: () => void
  onMouseEnter?: () => void
}

const Container = styled.div`
  position: relative;
  background-color: ${Theme.colors.BrandOrange};
  margin-bottom: 7px;
  height: ${({ selected }: Props) => selected ? '82px' : '72px'};
  padding-left: 74px;
  padding-right: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.1s ease-in-out;
  user-select: none;
  cursor: pointer;

  ${({ selected }: Props) => {
    if (selected) {
      return `
        min-width: 370px;
        width: 33vw;
        max-width: 33vw;
        z-index: 1;
        @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
          max-width: calc(100%);
          min-width: 100%;
          padding-right: 20px;
          padding-left: 20px;
        }
        `;
    } else {
      return `
        min-width: 340px;
        width: 30vw;
        max-width: 30vw;
        opacity: 0.9;
        z-index: 1;
        @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
          max-width: calc(100%);
          min-width: calc(100%);
          padding-right: 20px;
          padding-left: 20px;
        }
      `;
    }
  }}

  :hover {
    height: 82px;
    min-width: 370px;
    width: 33vw;
    max-width: 33vw;
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
      max-width: calc(100% - 40px);
      min-width: 100%;
      padding-right: 20px;
      padding-left: 20px;
    }
    z-index: 1;
    opacity: 1;
  }

  .chapter-name-container {
    max-width: 208px;
    font-weight: bold;  
  }
`;

const ChapterMenuItem = ({ selected, name, number, onClick, onMouseEnter }: Props) => {
  return (
    <Container onClick={onClick} selected={selected} onMouseEnter={onMouseEnter}>
      <div className='chapter-name-container'>
        <Text variant='Header6'>{name}</Text>
      </div>
      <Text variant='Header7'>{number}</Text>
    </Container>
  );
};

export default ChapterMenuItem;